<ng-container *ngIf="header$ | async as header">
  <app-dashboard-shell
    title="Revenue Dashboard"
    [lastReload]="header.lastReload"
    [loading]="header.loading"
    [showRefresh]="true"
    (refresh)="triggerReload()"
    class="revenue-container"
  >
    <ng-container *ngIf="header.errors">
      <ng-container *ngIf="header.errors.length">
        <!-- Error messages sit above the grid columns -->
        <div class="p-col-12">
          <div class="error-container" [id]="errorContainerId">
            <p-message
              *ngFor="let error of header.errors"
              severity="error"
              [text]="error"
            ></p-message>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="dashboard-container p-col-12 p-md-6 p-grid column">
      <div class="p-col-12">
        <app-revenue></app-revenue>
      </div>

      <div class="p-col-12 p-md-6">
        <div
          class="dashboard-card"
          *ngIf="averageInvoiceSize$ | async as averageInvoiceSize"
        >
          <div class="dashboard-card-header">
            <h6 class="p-mb-0">Average Invoice Size</h6>
            <div class="card-header-actions">
              <app-error-icon
                *ngIf="averageInvoiceSize.error"
                [error]="averageInvoiceSize.error"
              ></app-error-icon>
              <app-dashboard-info-v2>
                <div class="p-mb-2">
                  {{ averageInvoiceSize.description }}
                </div>
                <a
                  [routerLink]="['/reports', 'dynamic', 'new']"
                  [queryParams]="averageInvoiceSize.queryParams"
                  target="_blank"
                  >View Report</a
                >.
              </app-dashboard-info-v2>
            </div>
          </div>
          <app-dashboard-number
            [loading]="averageInvoiceSize.loading"
            [large]="true"
            mode="currency"
            [amount]="averageInvoiceSize.average.amount"
            [currency]="averageInvoiceSize.average.currency"
            [params]="averageInvoiceSize.queryParams"
          ></app-dashboard-number>
          <app-delta [delta]="averageInvoiceSize.delta"></app-delta>
        </div>
      </div>

      <div class="p-col-12 p-md-6">
        <div
          class="dashboard-card"
          *ngIf="averageJobSize$ | async as averageJobSize"
        >
          <div class="dashboard-card-header">
            <h6 class="p-mb-0">Average Lead Size</h6>
            <div class="card-header-actions">
              <app-error-icon
                *ngIf="averageJobSize.error"
                [error]="averageJobSize.error"
              ></app-error-icon>
              <app-dashboard-info-v2>
                <div class="p-mb-2">
                  {{ averageJobSize.description }}
                </div>
                <a
                  [routerLink]="['/reports', 'dynamic', 'new']"
                  [queryParams]="averageJobSize.queryParams"
                  target="_blank"
                  >View Report</a
                >.
              </app-dashboard-info-v2>
            </div>
          </div>
          <app-dashboard-number
            [loading]="averageJobSize.loading"
            [large]="true"
            mode="currency"
            [amount]="averageJobSize.average.amount"
            [currency]="averageJobSize.average.currency"
            [params]="averageJobSize.queryParams"
          ></app-dashboard-number>
          <app-delta [delta]="averageJobSize.delta"></app-delta>
        </div>
      </div>

      <div class="p-col-12 p-md-6">
        <div
          class="dashboard-card"
          *ngIf="averageBookingSize$ | async as averageBookingSize"
        >
          <div class="dashboard-card-header">
            <h6 class="p-mb-0">Average Booking Size</h6>
            <div class="card-header-actions">
              <app-error-icon
                *ngIf="averageBookingSize.error"
                [error]="averageBookingSize.error"
              ></app-error-icon>
              <app-dashboard-info-v2>
                <div class="p-mb-2">
                  {{ averageBookingSize.description }}
                </div>
                <a
                  [routerLink]="['/reports', 'dynamic', 'new']"
                  [queryParams]="averageBookingSize.queryParams"
                  target="_blank"
                  >View Report</a
                >.
              </app-dashboard-info-v2>
            </div>
          </div>
          <app-dashboard-number
            [loading]="averageBookingSize.loading"
            [large]="true"
            mode="currency"
            [amount]="averageBookingSize.average.amount"
            [currency]="averageBookingSize.average.currency"
            [params]="averageBookingSize.queryParams"
          ></app-dashboard-number>
          <app-delta [delta]="averageBookingSize.delta"></app-delta>
        </div>
      </div>

      <div class="p-col-12 p-md-6">
        <div
          class="dashboard-card"
          *ngIf="averageScheduledJobSize$ | async as averageScheduledJobSize"
        >
          <div class="dashboard-card-header">
            <h6 class="p-mb-0">Average Job Size</h6>
            <div class="card-header-actions">
              <app-error-icon
                *ngIf="averageScheduledJobSize.error"
                [error]="averageScheduledJobSize.error"
              ></app-error-icon>
              <app-dashboard-info-v2>
                <div class="p-mb-2">
                  {{ averageScheduledJobSize.description }}
                </div>
                <a
                  [routerLink]="['/reports', 'dynamic', 'new']"
                  [queryParams]="averageScheduledJobSize.queryParams"
                  target="_blank"
                  >View Report</a
                >.
              </app-dashboard-info-v2>
            </div>
          </div>
          <app-dashboard-number
            [loading]="averageScheduledJobSize.loading"
            [large]="true"
            mode="currency"
            [amount]="averageScheduledJobSize.average.amount"
            [currency]="averageScheduledJobSize.average.currency"
            [params]="averageScheduledJobSize.queryParams"
          ></app-dashboard-number>
          <app-delta [delta]="averageScheduledJobSize.delta"></app-delta>
        </div>
      </div>

      <div class="p-col-12">
        <app-activity></app-activity>
      </div>
    </div>

    <div class="dashboard-container p-col-12 p-xl-6 p-grid p-flex-column">
      <ng-container *ngIf="events$ | async as events">
        <div class="p-col-12">
          <div class="dashboard-card">
            <div class="dashboard-card-header">
              <div>
                <h4 class="p-mb-1">Created events</h4>
              </div>
              <div class="card-header-actions">
                <app-error-icon
                  *ngIf="events.eventsCreatedError"
                  [error]="events.eventsCreatedError"
                ></app-error-icon>
                <app-dashboard-info-v2>
                  <div class="p-mb-2">
                    A breakdown of all events created in the selected period into
                    their various types.
                  </div>
                  <div class="p-mb-2">
                    <a
                      [routerLink]="['/reports', 'dynamic', 'new']"
                      [queryParams]="events.createdQueryParams"
                      target="_blank"
                      >View Report</a
                    >.
                  </div>
                </app-dashboard-info-v2>
              </div>
            </div>

            <p-blockUI
              [target]="eventsCreated"
              [blocked]="events.createdLoading"
              [autoZIndex]="false"
            >
              <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
            </p-blockUI>

            <app-blockable #eventsCreated>
              <ng-container *ngIf="!events.createdEmpty">
                <div class="table-scroll">
                  <table class="events-table">
                    <thead>
                      <th *ngFor="let header of events.eventsCreated.headers">
                        {{ header | rename: 'average' : 'Average' : false }}
                      </th>
                    </thead>
                    <tr *ngFor="let row of events.eventsCreated.rows">
                      <td *ngFor="let cell of row">{{ cell }}</td>
                    </tr>
                  </table>
                </div>
              </ng-container>
              <app-dashboard-empty-state
                *ngIf="events.createdEmpty"
                text="No events created during the selected period"
              ></app-dashboard-empty-state>
            </app-blockable>
          </div>
        </div>

        <div class="p-col-12">
          <div class="dashboard-card">
            <div class="dashboard-card-header">
              <div>
                <h4 class="p-mb-1">Scheduled events</h4>
              </div>
              <div class="card-header-actions">
                <app-error-icon
                  *ngIf="events.eventsHappeningError"
                  [error]="events.eventsHappeningError"
                ></app-error-icon>
                <app-dashboard-info-v2>
                  <div class="p-mb-2">
                    A breakdown of all events scheduled for the selected period into
                    their various types.
                  </div>
                  <div class="p-mb-2">
                    <a
                      [routerLink]="['/reports', 'dynamic', 'new']"
                      [queryParams]="events.happeningQueryParams"
                      target="_blank"
                      >View Report</a
                    >.
                  </div>
                </app-dashboard-info-v2>
              </div>
            </div>

            <p-blockUI
              [target]="eventsHappening"
              [blocked]="events.happeningLoading"
              [autoZIndex]="false"
            >
              <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
            </p-blockUI>

            <app-blockable #eventsHappening>
              <ng-container *ngIf="!events.happenginEmpty">
                <div class="table-scroll">
                  <table class="events-table">
                    <thead>
                      <th *ngFor="let header of events.eventsHappening.headers">
                        {{ header | rename: 'average' : 'Average' : false }}
                      </th>
                    </thead>
                    <tr *ngFor="let row of events.eventsHappening.rows">
                      <td *ngFor="let cell of row">{{ cell }}</td>
                    </tr>
                  </table>
                </div>
              </ng-container>
              <app-dashboard-empty-state
                *ngIf="events.happeningEmpty"
                text="No events scheduled for the selected period"
              ></app-dashboard-empty-state>
            </app-blockable>
          </div>
        </div>
      </ng-container>
    </div>
  </app-dashboard-shell>
</ng-container>
